import { ShieldOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, Card } from '../components/ui'
import { homePathFor } from '../app/access'
import { useAuthStore } from '../stores/authStore'

export default function AccessDeniedPage() {
  const navigate = useNavigate()
  const permissions = useAuthStore((state) => state.user?.permissions ?? [])

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl items-center justify-center">
      <Card className="w-full" role="alert">
        <Card.Body className="flex flex-col items-center px-8 py-12 text-center">
          <div className="mb-5 rounded-full bg-zinc-100 p-4 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300">
            <ShieldOff className="h-8 w-8" aria-hidden="true" />
          </div>
          <h1 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100">
            Нет доступа к разделу
          </h1>
          <p className="mt-2 max-w-md text-sm text-zinc-600 dark:text-zinc-400">
            Раздел закрыт для вашей роли. Обратитесь к администратору, если доступ нужен для работы.
          </p>
          <Button className="mt-6" onClick={() => navigate(homePathFor(permissions), { replace: true })}>
            В рабочий раздел
          </Button>
        </Card.Body>
      </Card>
    </div>
  )
}
